import React from 'react';
import { productExtras } from '../data/productExtras';
import { Wrench, PackageCheck, BookOpen, BarChart3, Building2 } from 'lucide-react';

export const ProductExtraSections = ({ slug }) => {
  const x = productExtras[slug];
  if (!x) return null;

  return (
    <div data-testid={`product-extras-${slug}`}>
      {/* Buying Guide */}
      <section className="py-14 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-gray-900 mb-4 flex items-center gap-3">
            <BookOpen size={24} className="text-emerald-600" /> Buying Guide: Is This the Right Robot for You?
          </h2>
          <p className="text-gray-600 leading-relaxed">{x.buyingGuide}</p>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-14 px-6 lg:px-12 bg-[#F8F9FA]">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
            <BarChart3 size={24} className="text-emerald-600" /> How It Compares
          </h2>
          <div className="overflow-x-auto rounded-2xl border border-black/5 bg-white">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-black/5 bg-gray-50">
                  {x.comparison.columns.map((c, i) => (
                    <th key={c || 'f'} className={`px-4 py-3 text-left font-semibold ${i === 1 ? 'text-emerald-700' : 'text-gray-700'}`}>{c}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {x.comparison.rows.map((row) => (
                  <tr key={row[0]} className="border-b border-black/5 last:border-0">
                    {row.map((cell, i) => (
                      <td key={`${row[0]}-${i}`} className={`px-4 py-3 ${i === 0 ? 'font-medium text-gray-900' : i === 1 ? 'text-emerald-700 font-medium' : 'text-gray-600'}`}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Installation + Maintenance */}
      <section className="py-14 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <PackageCheck size={22} className="text-emerald-600" /> Installation Process
            </h2>
            <ol className="space-y-3">
              {x.installation.map((step, i) => (
                <li key={step} className="flex gap-3 text-sm text-gray-600">
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold">{i + 1}</span>
                  {step}
                </li>
              ))}
            </ol>
          </div>
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-gray-900 mb-5 flex items-center gap-3">
              <Wrench size={22} className="text-emerald-600" /> Maintenance Guide
            </h2>
            <ul className="space-y-3">
              {x.maintenance.map((m) => (
                <li key={m} className="flex gap-3 text-sm text-gray-600">
                  <span className="text-emerald-500 mt-0.5">✓</span>
                  {m}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Case Study */}
      <section className="py-14 px-6 lg:px-12 bg-[#0A0A0A]">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-4 flex items-center gap-3">
            <Building2 size={24} className="text-emerald-400" /> {x.caseStudy.title}
          </h2>
          <p className="text-gray-300 leading-relaxed">{x.caseStudy.body}</p>
        </div>
      </section>
    </div>
  );
};

export default ProductExtraSections;
